import { H2 } from '../../Primitives/Heading';
import css from './SectionBrands.module.css';

const SectionBrands = ({ blocks, title }) => {
  return (
    <section className={css.brands_wrapper}>
      <div className={css.brands}>
        <H2>{title}</H2>
        <ul>
          {blocks.map(brand => {
            return (
              <a key={brand.blockName} href={brand.media.link.href}>
                <li>
                  <img
                    className={css.brand_img}
                    src={brand.media.image.attributes.variants.original400.url}
                  />
                  <p className={css.brand_name}>{brand.blockName}</p>
                </li>
              </a>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default SectionBrands;
